/**
 * @module constants/colors
 * @desc DHIS2 color values
 */
export const colors = {
    /*blue*/
    blue900: '#093371',
    blue800: '#0d47a1',
    blue700: '#1565c0',
    blue600: '#147cd7',
    blue500: '#2196f3',
    blue400: '#42a5f5',
    blue300: '#90caf9',
    blue200: '#c5e3fc',
    blue100: '#e3f2fd',
    blue050: '#f5fbff',

    /*teal*/
    teal900: '#00332b',
    teal800: '#004d40',
    teal700: '#00695c',
    teal600: '#00796b',
    teal500: '#00897b',
    teal400: '#009688',
    teal300: '#4db6ac',
    teal200: '#b2dfdb',
    teal100: '#e0f2f1',
    teal050: '#f1f9f9',

    /*red*/
    red900: '#330202',
    red800: '#891515',
    red700: '#b71c1c',
    red600: '#c62828',
    red500: '#d32f2f',
    red400: '#f44336',
    red300: '#e57373',
    red200: '#ffcdd2',
    red100: '#ffe5e8',
    red050: '#fff5f6',

    /*yellow*/
    yellow900: '#6f3205',
    yellow800: '#bb460d',
    yellow700: '#e56408',
    yellow600: '#ff8302',
    yellow500: '#ff9302',
    yellow400: '#ffa902',
    yellow300: '#ffc324',
    yellow200: '#ffe082',
    yellow100: '#ffecb3',
    yellow050: '#fff8e1',

    /*green*/
    green900: '#103713',
    green800: '#1b5e20',
    green700: '#2e7d32',
    green600: '#388e3c',
    green500: '#43a047',
    green400: '#4caf50',
    green300: '#a5d6a7',
    green200: '#c8e6c9',
    green100: '#e8f5e9',
    green050: '#f4fbf4',

    /*grey*/
    grey900: '#212934',
    grey800: '#404b5a',
    grey700: '#4a5768',
    grey600: '#6e7a8a',
    grey500: '#a0adba',
    grey400: '#d5dde5',
    grey300: '#e8edf2',
    grey200: '#f3f5f7',
    grey100: '#f8f9fa',
    grey050: '#fbfcfd',

    white: '#ffffff',
}
